// A report goes to the saved session's relay, else the app's configured build relay;
// no relay is built in, so with neither the report stays local.
const SESSION_KEY = "cyborg7-session";
// On globalThis, like the other client-telemetry settings, so it survives vi.resetModules().
const FALLBACK_RELAY_KEY = "__cyborg7ClientRelayBase__";
const SESSION_READER_KEY = "__cyborg7ClientSessionReader__";
// cast: globalThis is where the client-telemetry settings live.
const settings = globalThis;
/** The build's relay, used while no session is saved; undefined or "" clears it. */
export function setFallbackRelayBase(base) {
    const trimmed = base?.trim();
    if (trimmed)
        settings[FALLBACK_RELAY_KEY] = trimmed;
    else
        delete settings[FALLBACK_RELAY_KEY];
}
/** The app's saved-session reader: a session the app refuses is never a target. */
export function setSessionReader(reader) {
    if (reader)
        settings[SESSION_READER_KEY] = reader;
    else
        delete settings[SESSION_READER_KEY];
}
function fallbackRelayUrl() {
    const base = settings[FALLBACK_RELAY_KEY];
    return typeof base === "string" && base ? base : undefined;
}
// ws(s)://host[/api/ws] → http(s)://host. Identical transform to
// client.ts `relayHttpBaseFromWsUrl`.
function httpBaseFromWsUrl(wsUrl) {
    return wsUrl
        .replace(/^ws:/, "http:")
        .replace(/^wss:/, "https:")
        .replace(/\/api\/ws\/?$/, "")
        .replace(/\/ws\/?$/, "");
}
function readSavedSession() {
    try {
        const reader = settings[SESSION_READER_KEY];
        if (typeof reader === "function")
            return reader();
        if (typeof localStorage === "undefined" || !localStorage)
            return null;
        const raw = localStorage.getItem(SESSION_KEY);
        if (!raw)
            return null;
        const parsed = JSON.parse(raw);
        return parsed && typeof parsed === "object" ? parsed : null;
    }
    catch {
        // intentional: an unreadable session is no session; reporting must never throw or loop.
        return null;
    }
}
function savedSessionWsUrl() {
    const url = readSavedSession()?.url;
    return typeof url === "string" && url ? url : null;
}
/**
 * The login token saved beside the relay url, or null (pre-login, or no url saved).
 * Only ever paired with THAT session's relay: with no saved url the beacon goes to
 * the build's fallback relay, which this token was not issued for.
 */
export function savedSessionToken() {
    const session = readSavedSession();
    if (typeof session?.url !== "string" || !session.url)
        return null;
    return typeof session.token === "string" && session.token ? session.token : null;
}
/** The relay's HTTP origin; "" when it is the page's own origin, undefined when none is known. */
export function resolveRelayBase() {
    const wsUrl = savedSessionWsUrl() ?? fallbackRelayUrl();
    if (!wsUrl)
        return undefined;
    const relayHttpBase = httpBaseFromWsUrl(wsUrl);
    try {
        if (typeof window !== "undefined" && window.location?.origin) {
            // Same origin as the page → relative path (keeps the beacon first-party).
            if (new URL(relayHttpBase).origin === window.location.origin) {
                return "";
            }
        }
    }
    catch {
        // Malformed origin — fall back to the absolute relay base.
    }
    return relayHttpBase;
}
//# sourceMappingURL=relay-url.js.map